<script>
  import { getContext } from "svelte";
  import { Router, Route, Link, navigate } from "svelte-routing";
  import { LOCATION } from "svelte-routing/src/contexts";
  import Select from "components/Select.svelte";

  export let panes;
  export let baseUrl;

  const getProps = ({ location, href, isPartiallyCurrent, isCurrent }) => {
    // const isActive = href === "/" ? isCurrent : isPartiallyCurrent || isCurrent;

    // The object returned here is spread on the anchor element's attributes
    if (isCurrent) {
      return { class: "tab active" };
    }
    return { class: "tab" };
  };

  const location = getContext(LOCATION);
  $: currentPath = $location.pathname;

  $: currentPane = panes.find((pane) => baseUrl + pane.relUrl == currentPath);

  const handleChange = (e) => {
    const selectedPane = e.detail;
    navigate(baseUrl + selectedPane.relUrl);
  };
</script>

<div>
  <div class="tabs">
    {#each panes as pane (pane.relUrl)}
      <Link to={baseUrl + pane.relUrl} {getProps}>{pane.label}</Link>
    {/each}
  </div>

  <div class="tabs-mobile">
    <Select {panes} {currentPane} on:change={handleChange} />
  </div>
  <Router>
    {#each panes as pane (pane.relUrl)}
      <Route path={pane.relUrl} let:params>
        <svelte:component
          this={pane.component}
          params
          {...pane.props}
          {...$$props}
        />
      </Route>
    {/each}
  </Router>
</div>

<style>
  .tabs {
    display: none;
    margin: 24px 0;
  }

  .tabs-mobile {
    display: block;
  }

  @media only screen and (min-width: 600px) {
    .tabs-mobile {
      display: none;
    }

    .tabs {
      display: block;
    }
  }
</style>
